<template>
    <input type="hidden" :value="token" name="_token" />
</template>

<style>

    @import '../../sass/_global_variables.scss';

</style>

<script>
    export default{
        data: function() {
            return {
                token: ''
            }
        },

        mounted: function() {
            this.token = Vue.http.headers.common['X-CSRF-TOKEN'];
        }
    }
</script>



// WEBPACK FOOTER //
// csrf-token.vue?0c1a69ce